import React from 'react'
import '../App.css'

function Step() {
    return (
        <>
            <section className="text-gray-600 body-font">
                <div className="container px-5 py-24 mx-auto flex flex-wrap">
                    <div className="flex flex-wrap w-full">
                        <div className="lg:w-3/5 md:w-1/2 md:pr-16 lg:pr-0 pr-0 my-auto lg:pl-32">
                            <h1 className="title-font font-bold sm:text-4xl text-3xl text-white ">Free Video Downloader
                            </h1>
                            <p className="leading-relaxed mt-6 text-gray-300 text-center sm:text-left">Easy to use, unlimited and free</p>

                            <div className="flex justify-center dispnoneMIN">
                                <a href="#form" className="mt-6 inline-flex text-white bg-[#1A56DB] border-0 py-2 px-6 focus:outline-none hover:bg-white hover:text-[#111827] rounded sm:text-lg font-semibold mx-auto " >Start Using</a>
                            </div>
                            <a href="#form" className="mt-6 inline-flex text-white bg-[#1A56DB] border-0 py-2 px-6 focus:outline-none hover:bg-white hover:text-[#111827] rounded sm:text-lg font-semibold mx-auto dispnoneMAX" >Start Using</a>

                        </div>
                        <div className="lg:w-2/5 md:w-1/2 md:pr-10 md:py-6 sm:mt-0 mt-12 sm:ml-0 ml-8">
                            <div className="flex relative pb-12">
                                <div className="h-full w-10 absolute inset-0 flex items-center justify-center">
                                    <div className="h-full w-1 bg-gray-200 pointer-events-none"></div>
                                </div>
                                <div className="flex-shrink-0 w-10 h-10 rounded-full  bg-[#1A56DB] inline-flex items-center justify-center text-white relative z-10">
                                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-5 h-5" viewBox="0 0 24 24">
                                        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                                    </svg>
                                </div>
                                <div className="flex-grow pl-4">

                                    <h2 className="font-medium title-font text-sm text-white mb-1 tracking-wider">STEP 1</h2>
                                    <h2 className="font-medium title-font text-sm text-white mb-1 tracking-wider">Copy shareable video URL</h2>

                                </div>
                            </div>
                            <div className="flex relative pb-12">
                                <div className="h-full w-10 absolute inset-0 flex items-center justify-center">
                                    <div className="h-full w-1 bg-gray-200 pointer-events-none"></div>
                                </div>
                                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#1A56DB] inline-flex items-center justify-center text-white relative z-10">
                                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-5 h-5" viewBox="0 0 24 24">
                                        <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"></path>
                                        <circle cx="12" cy="7" r="4"></circle>
                                    </svg>
                                </div>
                                <div className="flex-grow pl-4">
                                    <h2 className="font-medium title-font text-sm text-white mb-1 tracking-wider">STEP 2</h2>
                                    <h2 className="font-medium title-font text-sm text-white mb-1 tracking-wider">Paste it into the field above</h2>
                                </div>
                            </div>
                            <div className="flex relative">
                                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-[#1A56DB] inline-flex items-center justify-center text-white relative z-10">
                                    <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" className="w-5 h-5" viewBox="0 0 24 24">
                                        <path d="M22 11.08V12a10 10 0 11-5.93-9.14"></path>
                                        <path d="M22 4L12 14.01l-3-3"></path>
                                    </svg>
                                </div>
                                <div className="flex-grow pl-4">
                                    <h2 className="font-medium title-font text-sm text-white mb-1 tracking-wider">STEP 3</h2>
                                    <h2 className="font-medium title-font text-sm text-white mb-1 tracking-wider">Click to download button</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Step